
import React from 'react';
import {  hint} from '../../../constants/constants'
import {Tooltip} from '../'
export function InputCheckTools (props) {

  return (
    <label className='form__label_tools font20Norm colorGrey'>
      <input
        type="checkbox"
        className='form__input_course'
        name={props.name}
        value= {props.value}
        checked={props.checked}
        onChange={props.onChange}
        id={props.id}
      />
      <span className="visible-check item__link check__castom"></span>
      <span className={`castom__tools_item tool-${props.item.nameEn} large`}></span>
     {props.item.nameRu} 
    </label>  
  )
}
